import { FLEX_PRODUCTS } from "pages/FlexSetup/constants";
import React, { useState, useRef, useEffect } from "react";
import { planDisplayNameHandler } from "utlis/utils";

export default function PlanToggler({
    plans = [], // Array of string titles or items: ["Basic", "Pro", "Enterprise"]
    selectedPlan, // Optional controlled index
    setSelectedPlan,
    onSelect, // Callback when plan changes: (plan, index) => void
    customBackgroundColor = "#fdfbf7",
}) {
    const [activeIndex, setActiveIndex] = useState(0);
    const [sliderStyles, setSliderStyles] = useState({ left: 0, width: 0 });

    const containerRef = useRef(null);
    const tabsRef = useRef([]);

    // Sync internal active index if parent controls `selectedPlan`
    const currentTab = selectedPlan !== undefined ? selectedPlan : activeIndex;

    // Handle slider pill positioning & container centering
    useEffect(() => {
        const activeTabEl = tabsRef.current[currentTab];
        const containerEl = containerRef.current;

        if (activeTabEl) {
            // Set sliding pill dimensions
            setSliderStyles({
                left: activeTabEl.offsetLeft,
                width: activeTabEl.offsetWidth,
            });

            // Smooth horizontal scroll if items overflow
            if (containerEl) {
                const scrollOffset =
                    activeTabEl.offsetLeft -
                    containerEl.offsetWidth / 2 +
                    activeTabEl.offsetWidth / 2;

                containerEl.scrollTo({
                    left: Math.max(0, scrollOffset),
                    behavior: "smooth",
                });
            }
        }
    }, [currentTab, plans]);

    const handleSelect = (index) => {
        setActiveIndex(index);
        setSelectedPlan(plans[index])
        if (onSelect) {
            onSelect(plans[index], index);
        }
    };

    if (!plans || plans.length <= 1) {
        return null;
    }

    return (
        <div
            ref={containerRef}
            style={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                backgroundColor: customBackgroundColor,
                width: "100%",
                padding: "6px",
                borderRadius: "100px",
                overflowX: "auto",
                whiteSpace: "nowrap",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                boxSizing: "border-box",
            }}
            className="hide-scrollbar"
        >
            {/* Sliding Active Background Pill */}
            <div
                style={{
                    position: "absolute",
                    top: "6px",
                    bottom: "6px",
                    left: `${sliderStyles.left}px`,
                    width: `${sliderStyles.width}px`,
                    borderRadius: "100px",
                    border: "1px solid #C9C4CF",
                    boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.06)",
                    transition:
                        "left 0.3s cubic-bezier(0.25, 1, 0.5, 1), width 0.3s cubic-bezier(0.25, 1, 0.5, 1)",
                    zIndex: 1,
                    pointerEvents: "none",
                    boxSizing: "border-box",
                    background:
                        "linear-gradient(101deg, rgba(255, 248, 248, 0.16) -2.87%, rgba(201, 171, 245, 0.01) 28.91%, rgba(35, 26, 61, 0.33) 91.94%), rgba(255, 255, 255, 0.10)",
                }}
            />

            {/* Plan Buttons */}
            {plans.map((plan, index) => {
                const isActive = currentTab === index;
                const label = typeof plan === "object" ? plan.label || plan.name : plan;

                return (
                    <button
                        key={label || index}
                        ref={(el) => (tabsRef.current[index] = el)}
                        onClick={() => handleSelect(index)}
                        style={{
                            fontFamily: "Montserrat, sans-serif",
                            fontWeight: isActive ? "600" : "500",
                            fontSize: "14px",
                            lineHeight: "14px",
                            letterSpacing: "0px",
                            flex: 1,
                            minWidth: "fit-content",
                            position: "relative",
                            zIndex: 2,
                            background: "none",
                            border: "none",
                            padding: "12px 24px",
                            color: isActive ? "#000" : "#616060",
                            cursor: "pointer",
                            borderRadius: "100px",
                            outline: "none",
                            transition: "color 0.2s ease",
                            textAlign: "center",
                        }}
                    >
                        {planDisplayNameHandler(label)}
                        {/* {label} */}
                    </button>
                );
            })}

            <style>{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
      `}</style>
        </div>
    );
}